import * as React from 'react';
import { Field } from 'redux-form';
import { Button, Col, ControlLabel, Row } from 'react-bootstrap';
import SelectControl from '../../../../../../components/SelectControl';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../util/validators';

interface ISourceOption {
    value: string;
    label: string;
}

interface IProps {
    sources: ISourceOption[];
    productKey: string;
    change: (field: string, value: any) => void;
    camcMembership?: string;
    maydayBreakdown?: string;
}

export default class MembershipDetails extends React.PureComponent<IProps> {
    private handleMaydayYesClick = (e: React.MouseEvent<any>) => {
        e.preventDefault();
        this.props.change('maydayBreakdown', 'true');
    }

    private handleMaydayNoClick = (e: React.MouseEvent<any>) => {
        e.preventDefault();
        this.props.change('maydayBreakdown', 'false');
    }

    private handleCamcYesClick = (e: React.MouseEvent<any>) => {
        e.preventDefault();
        this.props.change('camcMembership', 'true');
    }

    private handleCamcNoClick = (e: React.MouseEvent<any>) => {
        e.preventDefault();
        this.props.change('camcMembership', 'false');
    }

    private productShowsMembershipNumber = (): false | 'a' | 'b' => {
        const mapping: { [key: string]: false | 'a' | 'b' } = {
            CSIS: 'a',
            TPL: false,
            CAMC: 'b',
        };

        return mapping[this.props.productKey] || false;
    }

    public render() {
        const { sources, camcMembership, maydayBreakdown } = this.props;

        const mode = this.productShowsMembershipNumber();
        if (!mode) { return null; }

        if (mode === 'a') {
            return (
                <div className="section">
                    <Row>
                        <Col sm={6} style={{ paddingLeft: 0 }}>
                            <ControlLabel>
                                Select the membership scheme you are part of from the list:
                            </ControlLabel>
                        </Col>
                        <Col sm={6}>
                            <Field
                                name="membershipScheme"
                                placeholder="Select your membership scheme"
                                options={sources}
                                component={SelectControl}
                                clearable={false}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6} style={{ paddingLeft: 0 }}>
                            <ControlLabel>Please provide your membership, employee or pension number:</ControlLabel>
                        </Col>
                        <Col sm={6}>
                            <Field
                                name="membershipNumber"
                                type="text"
                                placeholder="Enter your membership number"
                                component={FieldFormControl}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </div>
            );
        }

        return (
            <div className="section">
                <Row style={{ marginBottom: '30px' }}>
                    <Col sm={7} style={{ paddingLeft: 0 }}>
                        <ControlLabel>
                            Are you a member of the Caravan and Motorhome Club?
                        </ControlLabel>
                    </Col>

                    <Col sm={5}>
                        <div className="btn-bar btn-gap">
                            <Button
                                className="pull-right btn-primary-inverse"
                                onClick={this.handleCamcYesClick}
                                active={camcMembership === 'true'}
                            >
                                <span className="btn-text">Yes</span>
                            </Button>

                            <Button
                                className="pull-right btn-primary-inverse"
                                onClick={this.handleCamcNoClick}
                                active={camcMembership === 'false'}
                            >
                                <span className="btn-text">No</span>
                            </Button>

                            <Field
                                name="camcMembership"
                                component="input"
                                type="hidden"
                                validate={[isRequired]}
                            />
                        </div>
                    </Col>
                </Row>

                {camcMembership === 'true' && (
                    <div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col sm={7} style={{ paddingLeft: 0 }}>
                                <ControlLabel>Please Provide Your Membership number:</ControlLabel>
                            </Col>

                            <Col sm={5}>
                                <Field
                                    name="membershipNumber"
                                    type="text"
                                    placeholder="Enter your membership number"
                                    component={FieldFormControl}
                                />
                            </Col>
                        </Row>

                        <Row style={{ marginTop: '20px', marginBottom: '30px' }}>
                            <Col sm={7} style={{ paddingLeft: 0 }}>
                                <ControlLabel>
                                    Do you have a Mayday Breakdown cover policy?
                                </ControlLabel>
                            </Col>

                            <Col sm={5}>
                                <div className="btn-bar btn-gap">
                                    <Button
                                        id="yes-mayday"
                                        className="pull-right primary-inverse"
                                        onClick={this.handleMaydayYesClick}
                                        active={maydayBreakdown === 'true'}
                                    >
                                        <span className="btn-text">Yes</span>
                                    </Button>

                                    <Button
                                        id="no-mayday"
                                        className="pull-right primary-inverse"
                                        onClick={this.handleMaydayNoClick}
                                        active={maydayBreakdown === 'false'}
                                    >
                                        <span className="btn-text">No</span>
                                    </Button>

                                    <Field
                                        name="maydayBreakdown"
                                        component="input"
                                        type="hidden"
                                        validate={[isRequired]}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetailsJourneyB/components/MembershipDetails/index.tsx